import React from 'react'
import './Home.css'
function Heading(props) {
  return (
    <>
            <h1 className='main-heading'>
            {props.title}
            </h1>
    
    
    </>
  )
}

export default Heading
